import { render, staticRenderFns } from "./back-btn-group.vue?vue&type=template&id=7feee952"
import script from "./back-btn-group.vue?vue&type=script&lang=js"
export * from "./back-btn-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7feee952')) {
      api.createRecord('7feee952', component.options)
    } else {
      api.reload('7feee952', component.options)
    }
    module.hot.accept("./back-btn-group.vue?vue&type=template&id=7feee952", function () {
      api.rerender('7feee952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/error-page/back-btn-group.vue"
export default component.exports